import { computed, observable, action, makeObservable } from 'mobx';
import { getEnv, getRoot } from 'mobx-easy';
import { RootEnv } from '../../helpers/create-store';
import { ApiVersion, BaseCustomerExperienceData } from '@bringg/types';
import RootStore from '../root-store';

class CustomerExperienceStore {
	_customerExperience: BaseCustomerExperienceData = null;

	constructor() {
		makeObservable(this, {
			_customerExperience: observable,
			setCustomerExperienceConfig: action,
			customerExperience: computed
		});
	}

	setCustomerExperienceConfig(customerExperience: BaseCustomerExperienceData) {
		this._customerExperience = customerExperience;
	}

	// sharedLocationConfig may be used via this proxy if you want to support
	// related functionality both in V1 / V2 API
	get customerExperience() {
		const rootStore = getRoot<RootStore>();

		if (rootStore.apiVersion === ApiVersion.V1) {
			return rootStore.sharedLocationStore.sharedLocationConfig;
		}

		return this._customerExperience;
	}

	async initialize(sharedLocationUuid: string): Promise<BaseCustomerExperienceData> {
		try {
			const { customerExperienceService, langService } = getEnv<RootEnv>();
			const customerExperienceConfig = await customerExperienceService.getCustomerExperience(sharedLocationUuid);
			await langService.init(customerExperienceConfig.ui_data.languageCode);
			this.setCustomerExperienceConfig(customerExperienceConfig);
			return this.customerExperience as BaseCustomerExperienceData;
		} catch (error) {
			console.error(`Failed getting customer experience data: ${sharedLocationUuid}`, error);
		}
	}
}

export { CustomerExperienceStore };
